import { InjectionToken } from '@angular/core';
import { ServerLoggerConfig } from '../models/server-logger-config.interface';

export const ServerLoggerConfigToken = new InjectionToken<ServerLoggerConfig>('ServerLoggerConfig');
